import React from "react";
import { Layout } from "antd";

const { Content } = Layout;

const PageWrapper = ({ children, hideCard = false, isScrollable = true }) => {
  console.log("children", children);
  return (
    <div className="flex-1 p-4 flex flex-col overflow-auto customScrollbarMd">
      {hideCard ? (
        <div className="flex-1">{children}</div>
      ) : (
        <div className={`flex-1 ${!isScrollable ? "overflow-hidden" : ""}`}>
          <Content
            style={{
              margin: "0",
              height: "100%",
              background: "white",
              borderRadius: "6px",
            }}
            className="p-4 min-[540px]:p-[18px] border border-solid border-[rgba(1,1,1,0.1)]"
          >
            {children}
          </Content>
        </div>
      )}
    </div>
  );
};

export default PageWrapper;
